import type { FaireProductEntity } from "../../entity_types/product";

export const p_zs94fk7s43: FaireProductEntity = {
  token: "p_zs94fk7s43",
  type: "product",
  name: "Mahjong Floral Club Bag / Crossbody Bag",
  brandToken: "b_3r3tx0p8lp",
  brandName: "Bamboo Trading Company",
  imageUrl:
    "https://cdn.faire.com/fastly/ab805e2d6b01c282424105cb566f9bfcead709122b64f9f1fd47f97a604db497.png",
  galleryImageUrls: [],
  priceDollars: 18,
  description:
    'Hand beaded by artisans in India, this versatile smart phone bag can be worn cross body or as a wristlet. Includes 54" cross body strap that can tuck inside when not in use, a short strap that unsnaps so the bag can be attached to a larger bag or belt, and a separate, secure side zip pocket for cash and credit cards.\n\n4.5"W x 7.5"H\n\nOur Club Bags are changing the lives of over 1,000 people in Uttar Pradesh, India\'s poorest state. Your purchase makes a difference!',
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:49.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
